<template>
  <div
    class="container category-detail"
    data-test="category-detail">
    <loader
      v-show="!data_loaded"
      :with-margin="true"
      center
      label="Fetching category specific podcasts..."
    />
    <div>
      <h4 class="title">{{ category_type }}</h4>
      <el-row
        v-show="data_loaded"
        :gutter="16"
        type="flex"
        class="d-flex-wrap"
        data-test="d-flex">
        <el-col
          v-for="(item, index) in podcast"
          v-show="data_loaded"
          :key="index"
          :lg="{span: 6}"
          :md="{span: 5}"
          :sm="{span: 4}"
          :xs="{span: 3}"
          data-test="list-category-detail">
          <category-item
            :key="index"
            :title="item.title"
            :picture="item.display_image_url"
            :is-premium="item.is_exclusive"
            :redirect-link="makeRedirectLink(item)"
            data-test="podcast-category"/>
        </el-col>
      </el-row>
      <div v-if="current_route == 'publisherPage'">
        <h4 class="title">{{ list ? list.name : '' }}</h4>
        <podcast-grid
          v-if="list"
          :list="podcast"
          :heading="list ? list.name : '' "
          :bucket="bucket"
          type="podcast"
          data-test="podcast-publisher"/>
      </div>
    </div>
    <div class="t-c">
      <el-button
        v-loading="load_more"
        v-if="current_route == 'categoryPage' && data_loaded && podcast.length && !limit_reached"
        class="btn-transparent large"
        data-test="loadmore-podcast"
        @click="getPodcasts">Load More</el-button>
      <el-button
        v-loading="load_more"
        v-if="current_route == 'publisherPage' && data_loaded && podcast.length && !no_more_data"
        class="btn-transparent large"
        data-test="loadmore-publisher"
        @click="getPublishersDetails">Load More</el-button>
    </div>
    <div
      v-if="not_found && data_loaded"
      class="not-found">
      <img
        src="/static/500.svg"
        alt="not found">
      <h3>Record not found !</h3>
    </div>
    <div
      v-if="!podcast.length && !not_found && data_loaded"
      class="not-found">
      <img
        src="/static/500.svg"
        alt="not found">
      <h3>No podcasts available on page !</h3>
    </div>
  </div>
</template>
<script>
import * as log from 'loglevel';
import PodcastGrid from '../components/PodcastGrid';
import CategoryItem from '../components/CategoryItem';
import Loader from '../components/Loader';
import Podcast from '../services/Podcast';
import Publisher from '../services/Publisher';
import ScrollMixin from '../shared/scrollMixin';
import PageMixin from '../shared/pageMixin';

export default {
  name: 'CategoryDetails',
  components: {
    'podcast-grid': PodcastGrid,
    'category-item': CategoryItem,
    loader: Loader,
  },
  mixins: [ScrollMixin, PageMixin],
  data() {
    return {
      pageName: 'Single Category Page',
      list: [],
      podcast: [],
      category_type: '',
      data_loaded: false,
      load_more: false,
      not_found: false,
      uuid: null,
      podcast_service: new Podcast(),
      publisher_service: new Publisher(),
      current_route: '',
      limit: 25,
      dimensions: {
        // Screen size : Limit (per column * rows)
        1200: 30,
        1024: 25,
        768: 20,
        576: 15,
      },
      limit_reached: false,
      category_page: 1,
      publisher_page: 1,
      no_more_data: false,
      bucket: {},
    };
  },
  beforeMount() {
    this.contentLimitWidth();
    const route = this.$route;
    if (route && route.meta && route.meta.title && route.meta.title === 'categoryPage') {
      this.current_route = 'categoryPage';
      this.bucket = {
        uuid: null,
        name: 'Categories Page',
        bucket_type: 'podcasts',
        media_size: 'thumbnail',
      };
      this.getPodcasts();
      this.pageName = 'Single Category Page';
    } else if (route && route.meta && route.meta.title && route.meta.title === 'publisherPage') {
      this.current_route = 'publisherPage';
      this.bucket = {
        uuid: null,
        name: 'Publishers Page',
        bucket_type: 'podcasts',
        media_size: 'thumbnail',
      };
      this.getPublishersDetails();
      this.pageName = 'Single Publisher Page';
    }
  },
  destroyed() {
    this.setMetaInformation();
  },
  methods: {
    getPodcasts() {
      this.data_loaded = (this.category_page > 1);
      this.load_more = (this.category_page > 1);
      this.uuid = this.$route.params.categoryID;
      this.podcast_service.getPodcastByCategoryId(this.uuid, this.limit, this.category_page++)
        .then((res) => {
          log.info(res);
          this.category_type = res.category ? res.category.name : '';

          if (!res) {
            this.not_found = true;
            return;
          }
          this.podcast = this.podcast.concat(res.podcast || []);
          this.limit_reached = this.podcast.length < this.limit;

          this.setMetaInformation(`${this.category_type} Podcasts | Luminary`, `Discover ${this.category_type} podcasts. With 500k+ shows to choose from, Luminary is the best place to discover and listen to podcasts, when and where you want.`);
        })
        .catch((err) => {
          this.not_found = true;
          log.info(err.message);
        })
        .then(() => {
          this.data_loaded = true;
          this.load_more = false;
        });
    },
    getPublishersDetails() {
      this.data_loaded = (this.publisher_page > 1);
      this.load_more = (this.publisher_page > 1);
      const uuid = this.$route.params.publisherID;
      this.publisher_service.getPublisherDetails(uuid, this.limit, this.publisher_page++).then((resp) => {
        if (resp && resp.podcasts && resp.podcasts.length) {
          this.list = resp;
          const publisher = { ...resp };
          delete publisher.podcasts;

          let podcasts = resp.podcasts || [];
          podcasts = podcasts.map(podcast => ({
            ...podcast,
            publisher: { ...publisher },
          }));
          this.podcast = this.podcast.concat(podcasts);
          this.not_found = false;
          this.data_loaded = true;
          this.no_more_data = resp.podcasts.length < 25;
        }
        this.data_loaded = true;
        this.load_more = false;

        this.setMetaInformation(`${resp.name} Podcasts | Luminary`, 'With 500k+ shows to choose from, Luminary is the best place to discover and listen to podcasts, when and where you want.');
      })
        .catch(() => {
          this.not_found = true;
          this.data_loaded = true;
          this.load_more = false;
        });
    },
    contentLimitWidth() {
      /* eslint-disable */
      Object.keys(this.dimensions).forEach((item) => {
        if (this.currentScreenWidth >= item) {
          this.limit = this.dimensions[item];
          return;
        }
      });
      log.info(this.limit);
    },
    makeRedirectLink(item) {
      return `/listen/${item.publisher.slug}/${item.slug}/${item.uuid}`;
    }
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";
.category-detail {
  flex: 1;
  padding: 40px 0 50px;
  .title {
    margin: 0 0 30px 0;
    font-size: 32px;
    line-height: 36px;
  }
  .list-header {
    display: none;
  }
  .not-found{
    width: 500px;
    margin: 160px auto;

    img {
      display: block;
      width: 100px;
      height: 100px;
      margin: auto
    }
    h3 {
      text-align: center;
      color: #909399;
    }
  }
  .el-col {
    margin-bottom: 30px;
  }
}
@media(min-width: $lg) {
  .el-col-lg-6 {
    width: 16.66%;
  }
}
@media (max-width: $lg) {
  .el-col-md-5 {
    width: 20%;
  }
}
@media (max-width: $md) {
  .el-col-sm-4 {
    width: 25%;
  }
}
@media (max-width: $sm) {
  .el-col-xs-3 {
    width: 33%;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/CategoryDetail.vue